import type {Pinia, Store, StoreGeneric} from 'pinia';
import {appContextOptions} from '../appContextOptions';

export function createUseAppContext(appId: string) {
    function useAppContext(_pinia?: Pinia | null, hot?: StoreGeneric): Store {
        const {useAppContext} = appContextOptions.instances.get(appId)!;
        const {pinia} = appContextOptions;
        return useAppContext(_pinia ?? pinia, hot);
    }

    return useAppContext;
}
